export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/technical_writing.fea9a7f.svg";